module.exports = "/images/checkbox-unchecked.d2d32c0479cecfd5ae0534518e58d598.svg";